import { cn } from '@cobliteam/colib-ui/cn';
import Spinner from '@cobliteam/colib-ui/Spinner';
import { useTranslation } from '@cobliteam/i18n';
import { forwardRef } from 'react';

export type PageChunkLoadingPageProps = {
  message?: string;
  className?: string;
};

const PageChunkLoadingPage = forwardRef<HTMLDivElement, PageChunkLoadingPageProps>(({ message, className }, ref) => {
  const { t } = useTranslation('common');

  return (
    <div ref={ref} data-testid='page-chunk-loading' className={cn('flex h-screen flex-col items-center justify-center', className)} aria-busy='true'>
      <div role='status' aria-live='polite' className='flex flex-col items-center gap-3'>
        <Spinner className='size-10 text-primary' aria-hidden='true' />
        <span className={message ? 'text-center text-gray-11 text-sm' : 'sr-only'}>{message || t('messages.loading')}</span>
      </div>
    </div>
  );
});

PageChunkLoadingPage.displayName = 'PageChunkLoadingPage';

export default PageChunkLoadingPage;
